import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Tenets from "./sections/Tenets";
import History from "./sections/History";
import Legal from "./sections/Legal";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Tenets />
      <History />
      <Legal />
      <Footer />
    </div>;
}